const RawMaterialsIndex = () => import('./raw-materials/index.vue');
const CreateRawMaterial = () => import('./raw-materials/_pages/create.vue');
const ViewRawMaterial = () => import('./raw-materials/_pages/view.vue');

const ProductionIndex = () => import('./record-production/index.vue');
// new production
const CreateProduction = () => import('./record-production/new-production.vue');
const ProductionDetails = () => import('./record-production/details.vue');
const ManualProduction = () => import('./record-production/manual-production.vue');

// reports 
const RawMaterialsReport = () => import('./reports/raw-materials.vue');
const ProducedGoodsReport = () => import('./reports/produced-goods.vue');

// production template
const ProductionTemplateIndex = () => import('./production-templates/index.vue');
const NewProductionTemplate = () => import('./production-templates/new-template.vue');
const TemplateDetails = () => import('./production-templates/raw-materials.vue');

export default [
    {
        path: '/manual-production',
        component: ManualProduction
    },
    {
        path: '/new-production-template',
        component: NewProductionTemplate
    },
    {
        path: '/production-templates',
        component: ProductionTemplateIndex
    },
    {
        path: '/production-template/:id',
        component: TemplateDetails
    },
    {
        path: '/raw-materials-report',
        component: RawMaterialsReport
    },
    {
        path: '/produced-goods-report',
        component: ProducedGoodsReport
    },
    {
        path: '/production-records',
        component: ProductionIndex
    },
    {
        path: '/raw-materials',
        component: RawMaterialsIndex
    },
    {
        path: '/new-raw-material',
        component: CreateRawMaterial
    },
    {
        path: '/raw-material/:id',
        component: ViewRawMaterial
    },
    {
        path: '/production/new-production',
        component: CreateProduction
    },
    {
        path: '/production-details/:id',
        component: ProductionDetails
    },
];